import { withInstall } from '@tw-element/utils'

import Badge from './src/badge.vue'

export const TwBadge = withInstall(Badge)
export default TwBadge

export * from './src/badge'
